
/* eslint-disable no-restricted-globals */
import { history } from '../_helpers';

export const systemAuditService = {
    getAllSystemAudits,
    getSystemAuditTopCardInfo,
    applyFilter,
    fetchSystemAuditFilters,
};

function getAllSystemAudits(offset, limit) {
    let user = JSON.parse(localStorage.getItem("user"));
    const requestOptions = {
        method: "GET",
        headers: {
            "x-access-token": user.accessToken,
        },
    };

    return fetch(
        `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/system/audits/${offset}/${limit}`,
        requestOptions
    ).then(handleResponse);
}


function getSystemAuditTopCardInfo() {
    let user = JSON.parse(localStorage.getItem("user"));
    const requestOptions = {
        method: "GET",
        headers: {
            "x-access-token": user.accessToken,
        },
    };

    return fetch(
        `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/system/audits/cards`,
        requestOptions
    ).then(handleResponse);
}

function applyFilter(
    model,
    operation,
    user,
    startDate,
    endDate,
    search,
    offset,
    limit) {
    let users = JSON.parse(localStorage.getItem("user"));
    const sortBy = "DESC";
    const columnName = null;
    const requestOptions = {
        method: "POST",
        headers: {
            'x-access-token': users.accessToken,
            'content-type': 'application/json',
        },
        body: JSON.stringify({
            model,
            operation,
            user,
            startDate,
            endDate,
            search,
            offset,
            limit
        })
    };

    return fetch(
        `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/system/audits/filter/${limit}/${offset}/${sortBy}/${columnName}`,
        requestOptions
    ).then(handleResponse);
}
//fetchSystemAuditFilters
function fetchSystemAuditFilters() {
    let user = JSON.parse(localStorage.getItem("user"));
    const requestOptions = {
        method: "GET",
        headers: {
            "content-type": "application/json",
            "x-access-token": user.accessToken,
        },
    }
    return fetch(`${process.env.REACT_APP_BACKEND_API_URL}/api/v1/system/audits/filter/props`,
        requestOptions
    ).then(handleResponse);
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);

        if (!response.ok) {
            if (response.status === 401) {
                // location.reload(true);
            }
            // checking token expiry
            if (response.status === 401 && data.message.includes('Invalid JWT token')) {
                //redirecting to signin page
                history.push('/auth/signin')
                //removing local storage token
                localStorage.removeItem('user');
                return;
            }
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}